export const toggleDrawer = () => ({
    type: 'TOGGLE_DRAWER',
})